import * as React from 'react'
import Navbar from '../setup/Navbar'
import { Box, Container, Grid2, Typography } from '@mui/material'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import { getInvoiceForDB } from '../../features/StockReports/salesDashbaordSlice'
import { useDispatch, useSelector } from 'react-redux'
export default function SalesDashbaord() {

    const dispatch = useDispatch()
    const { user } = useSelector(state => state.auth)
    const { invoiceForDB } = useSelector(state => state.sd)

    React.useEffect(() => {
        // Function to fetch invoice data
        const fetchInvoices = () => {
            dispatch(getInvoiceForDB({ userID: user.userID }));
        };

        // Fetch data immediately on component mount
        fetchInvoices();

        // Set up interval to fetch data every 30 seconds
        const interval = setInterval(() => {
            fetchInvoices();
        }, 10000); // 30 seconds (30000 ms)

        // Clean up interval on component unmount
        return () => clearInterval(interval);
    }, [dispatch, user.userID]);

    return (
        <>
            <Navbar />
            <Container>
                <HeadingText text='Sales Dashbaord' />
                <Grid2 container spacing={2}>
                    {Object.keys(invoiceForDB).sort((a, b) => b - a).map((invoiceNumber) => (
                        <>
                            <Grid2 size={4}>
                                <Box sx={{
                                    backgroundColor: 'green', padding: 1, borderRadius: 3,
                                    boxShadow: 'grey 3px 3px 5px', color: 'white', height: 150
                                }}>

                                    <Typography sx={{
                                        textAlign: 'center', backgroundColor: '#005400', padding: 0.5,
                                        borderRadius: 2, fontWeight: 'bolder', fontSize: 30
                                    }}>{`Invoice # ${invoiceNumber}`}</Typography>

                                    {invoiceForDB[invoiceNumber].map((item, index) => (
                                        <Typography sx={{ mt: 1, fontSize: 20 }}>{`${index + 1} - ${item.itemDesc} | Quantity : ${item.itemQuantity}`}</Typography>
                                    ))}
                                    <Typography></Typography>
                                </Box>
                            </Grid2>
                        </>
                    ))}
                </Grid2>
            </Container>
        </>
    )
}